import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { PageState } from 'app/store/models/page.model';
import { setBannerComponent } from 'app/store/actions/page.action';

import { HomeBannerComponent } from './home-banner/home-banner.component';
import { HomeIntroduceComponent } from './home-introduce/home-introduce.component';
import { HomeResultsComponent } from './home-results/home-results.component';
import { HomeFeaturesComponent } from './home-features/home-features.component';
import { HomeTestimontionsComponent } from './home-testimontions/home-testimontions.component';
import { HomeSignupComponent } from './home-signup/home-signup.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  services = [
    {
      component: HomeIntroduceComponent,
    },
    {
      component: HomeResultsComponent,
    },
    {
      component: HomeFeaturesComponent,
    },
    {
      component: HomeTestimontionsComponent,
    },
    {
      component: HomeSignupComponent,
    },
  ];

  constructor(private store: Store<PageState>) {
    this.store.dispatch(setBannerComponent({ banner: HomeBannerComponent }));
  }

  ngOnInit() {}
}
